import styled from "styled-components";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { getFreebieImageSize } from "./config";

export const CardContainerWrapper = styled(CardContainer)<{ isUnlocked: boolean }>(({ theme, isUnlocked }) => {
    return {
        margin: `0 ${theme.spacing.medium} ${theme.spacing.medium}`,
        padding: theme.spacing.medium,
        border: `1.4px solid ${theme.colors[theme.colorMode].background_Primary}`,
        background: isUnlocked
            ? "radial-gradient(106.43% 103% at 4.88% 7.44%, rgba(27, 166, 114, 0.09) 0%, rgba(27, 166, 114, 0.00) 100%), #FFF;"
            : "radial-gradient(106.43% 103% at 4.88% 7.44%, rgba(60, 18, 178, 0.09) 0%, rgba(60, 18, 178, 0.00) 100%), #FFF;",
        position: "relative",
        overflow: "hidden",
    };
});

export const ItemContainer = styled(CardContainer)(({ theme }) => {
    return {
        display: "flex",
        padding: "14px",
        marginTop: theme.spacing.xSmall,
        alignItems: "center",
        borderRadius: theme.cornerRadius.small,
        borderColor: theme.colors[theme.colorMode].border_Tertiary,
        zIndex: 2, // to ensure the item container is above the lottie animation
        position: "relative",
    };
});

export const ImageContainer = styled.div<{ isSnaccStorefrontV2?: boolean }>(
    ({ theme, isSnaccStorefrontV2 = false }) => {
        const { width, height } = getFreebieImageSize(isSnaccStorefrontV2);
        return {
            width: `${width}px`,
            height: `${height}px`,
            overflow: "hidden",
            borderRadius: theme.cornerRadius.xSmall,
        };
    },
);

export const StyledImage = styled(Image)<{ isSnaccStorefrontV2?: boolean }>(({ isSnaccStorefrontV2 = false }) => {
    return {
        ...(isSnaccStorefrontV2 && {
            transform: "scale(1.6)",
            "transform-origin": "center",
        }),
    };
});

export const ButtonContainer = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
        alignSelf: "flex-end",
    };
});

export const ClaimButton = styled(FullWidthButton)<{ isDisabled: boolean }>(({ theme, isDisabled }) => {
    return {
        borderRadius: theme.cornerRadius.xSmall,
        border: isDisabled
            ? `1px solid ${theme.colors[theme.colorMode].border_Subtle_Secondary}`
            : `1px solid ${theme.colors[theme.colorMode].border_Primary}`,
        boxShadow: isDisabled ? "none" : "2px 2px 0 0 #000",
        height: "32px",
        width: "76px",
    };
});

export const ItemDetailsContainer = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        alignSelf: "flex-start",
    };
});

export const ItemName = styled.span(({ theme }) => {
    return {
        marginLeft: theme.spacing.xxSmall,
    };
});

export const HeaderContainer = styled.div(() => {
    return {
        display: "block",
        alignItems: "center",
    };
});

export const BasePriceContainer = styled(Text)`
    text-decoration: line-through;
    text-decoration-line: line-through;
    margin-right: ${(props) => props.theme.spacing.xxxSmall};
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: ${(props) => props.theme.spacing.xxSmall};
`;
